import { getServiceLevel, hasFeatureEnabled, ServiceLevel } from 'js/src/libs/server-utils';
import type { DAMConfig } from 'js/src/typings/global';
import Cookies from 'js-cookie';

const Flags = {
    canUseStaffControls: (): boolean => {
        return hasFeatureEnabled('staff_controls');
    },
    canSeeDamTab: (): boolean => {
        if (!window.SERVER?.USER?.dam_configs) {
            return false;
        }
        const damConfigs = window.SERVER.USER.dam_configs;
        return damConfigs.some((damConfig: DAMConfig) => {
            if (damConfig.require_connection && damConfig.is_connected) {
                return true;
            }
            if (!damConfig.require_connection) {
                return true;
            }
            return false;
        });
    },
    canSeeAiContextSettings: () => {
        return hasFeatureEnabled('ai_context_settings');
    },
    canUseChat: () => {
        return hasFeatureEnabled('chat');
    },
    canUseStickers: () => {
        return hasFeatureEnabled('stickers');
    },
    canUseCustomTiming: () => {
        return hasFeatureEnabled('custom_timing');
    },
    chatTabDeveloperToolsEnabled: () => {
        return Cookies.get('chat_tab_developer_tools') === 'true';
    },
    isTOMDisabled: () => {
        return hasFeatureEnabled('tom_disabled');
    },
    canUseScreenRecording: () => {
        return window.SERVER?.USER?.capabilities?.screen_recording ?? true;
    },
    canUseBlueprintAgent: () => {
        return hasFeatureEnabled('blueprint_agent');
    },
    canUseImproveMediaAgent: () => {
        return process.env.NODE_ENV !== 'test';
    },
    canUseAgentFamily: () => {
        if (getServiceLevel() === ServiceLevel.HIGH) {
            return Flags.canUseImproveMediaAgent() || Flags.canUseBlueprintAgent();
        } else {
            return false;
        }
    },
    canUseVideoGeneration: () => {
        return hasFeatureEnabled('video_generation');
    },
    canUseBuildVideoFromMediaAgent: () => {
        return hasFeatureEnabled('build_video_from_media_agent');
    },
    canUseBuildGenerativeMediaVideoAgent: () => {
        return hasFeatureEnabled('build_video_with_generative_media_agent');
    },
    isPixelContrastChecksDisabled: () => {
        return hasFeatureEnabled('disable_pixel_contrast_checks');
    },
    canUseSketchModes: () => {
        return (
            Flags.canUseBuildVideoFromMediaAgent() || Flags.canUseBuildGenerativeMediaVideoAgent()
        );
    },
    canUseMediaAge: () => {
        return hasFeatureEnabled('enrich_media_age');
    },
    optOutAutoBlueprints: () => {
        return hasFeatureEnabled('opt_out_auto_blueprints');
    },
};

export default Flags;
